module.exports = __webpack_public_path__ + "static/media/Logo-Bloclit-v1.f3d82484.png";